import { Device, DeviceInfo } from "@capacitor/device";
import { v5 as uuidv5 } from 'uuid';


export async function getUUIDAndroid(): Promise<string> {
    const infoDevice:DeviceInfo = await Device.getInfo();
    const MY_NAMESPACE = 'd3002e7d-2ee7-409b-b2c6-93b06766fa1b';
    return uuidv5(`${infoDevice.manufacturer} ${infoDevice.model}`, MY_NAMESPACE);
}